<template>
  <div class="ud-page">
    <div class="ud-container">

      <!-- Page header -->
      <div class="ud-header">
        <div class="ud-header-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <h1 class="ud-header-title">تعديل البيانات الشخصية</h1>
        <p class="ud-header-sub">يمكنك تحديث بياناتك في أي وقت</p>
      </div>

      <!-- Form card -->
      <div class="ud-card" v-if="!pageLoading">
        <form @submit.prevent="sendForm" novalidate>

          <!-- Section: personal info -->
          <div class="ud-section">
            <div class="ud-section-label">
              <span class="ud-section-dot"></span>
              المعلومات الشخصية
            </div>
            <div class="ud-fields-grid">

              <!-- Student name -->
              <div class="ud-field" :class="{ 'ud-field--error': v$.student_name.$error }">
                <label class="ud-label">
                  اسم الطالب
                  <span class="ud-req">*</span>
                </label>
                <div class="ud-input-wrap">
                  <span class="ud-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  </span>
                  <input type="text" v-model="student_name" class="ud-input" placeholder="الاسم كاملاً" />
                </div>
                <span class="ud-error" v-if="v$.student_name.$error">برجاء إدخال اسم الطالب</span>
              </div>

              <!-- Address -->
              <div class="ud-field">
                <label class="ud-label">
                  العنوان
                  <span class="ud-opt">(اختياري)</span>
                </label>
                <div class="ud-input-wrap">
                  <span class="ud-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  </span>
                  <input type="text" v-model="address" class="ud-input" placeholder="المدينة / الحي" />
                </div>
              </div>

            </div>
          </div>

          <!-- Section: phone numbers -->
          <div class="ud-section">
            <div class="ud-section-label">
              <span class="ud-section-dot"></span>
              أرقام الهواتف
            </div>
            <div class="ud-fields-grid">

              <!-- Student phone -->
              <div class="ud-field" :class="{ 'ud-field--error': v$.student_phone.$error }">
                <label class="ud-label">
                  رقم هاتف الطالب
                  <span class="ud-req">*</span>
                </label>
                <div class="ud-input-wrap">
                  <span class="ud-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 01.22 2.38 2 2 0 012.2.22h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.1 6.1l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                  </span>
                  <input type="tel" v-model="student_phone" class="ud-input" placeholder="01XXXXXXXXX" dir="ltr" @keypress="onlyNumbers" inputmode="tel" />
                </div>
                <span class="ud-error" v-if="v$.student_phone.$error">برجاء إدخال رقم هاتف الطالب</span>
              </div>

              <!-- Parent phone -->
              <div class="ud-field" :class="{ 'ud-field--error': v$.parent_phone.$error }">
                <label class="ud-label">
                  رقم هاتف ولي الأمر
                  <span class="ud-req">*</span>
                </label>
                <div class="ud-input-wrap">
                  <span class="ud-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 01.22 2.38 2 2 0 012.2.22h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.1 6.1l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                  </span>
                  <input type="tel" v-model="parent_phone" class="ud-input" placeholder="01XXXXXXXXX" dir="ltr" @keypress="onlyNumbers" inputmode="tel" />
                </div>
                <span class="ud-error" v-if="v$.parent_phone.$error">برجاء إدخال رقم هاتف ولي الأمر</span>
              </div>

            </div>

            <!-- Phone change warning -->
            <div class="ud-phone-warn" v-if="student_phone && student_phone != user?.phone">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ud-warn-icon"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <span>سيتم تغيير كلمة مرورك إلى رقم هاتفك الجديد: <strong>{{ student_phone }}</strong></span>
            </div>
          </div>

          <!-- Section: education -->
          <div class="ud-section">
            <div class="ud-section-label">
              <span class="ud-section-dot"></span>
              نظام التعليم
            </div>
            <div class="ud-fields-grid">
              <div class="ud-field" :class="{ 'ud-field--error': v$.selected_type.$error }">
                <label class="ud-label">
                  نظام التعليم
                  <span class="ud-req">*</span>
                </label>
                <!-- Custom type selector -->
                <div class="ud-type-options">
                  <button
                    type="button"
                    v-for="t in types"
                    :key="t.id"
                    class="ud-type-btn"
                    :class="{ 'ud-type-btn--active': selected_type?.id === t.id }"
                    @click="selected_type = t"
                  >
                    {{ t.name }}
                  </button>
                </div>
                <span class="ud-error" v-if="v$.selected_type.$error">برجاء اختيار نظام التعليم</span>
              </div>
            </div>
          </div>

          <!-- Submit row -->
          <div class="ud-actions">
            <button type="submit" class="ud-submit" :disabled="formSending">
              <span v-if="!formSending">💾 حفظ التعديلات</span>
              <span v-else class="ud-spinner"></span>
            </button>
          </div>

        </form>
      </div>

      <!-- Page skeleton -->
      <div v-else class="ud-card ud-skeleton">
        <div class="skel skel-title"></div>
        <div class="ud-fields-grid" style="margin-top:1.5rem">
          <div class="skel skel-field" v-for="n in 4" :key="n"></div>
        </div>
        <div class="skel skel-btn" style="margin-top:2rem"></div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "user-edit",
  data() {
    return {
      v$: useVuelidate(),
      student_name: "",
      student_phone: null,
      parent_phone: null,
      address: "",
      math_degree: null,
      certificate_image: "",
      imageEntry: "",
      fileData: "",
      formSending: false,
      pageLoading: true,
      selected_gender: null,
      selected_type: null,
      user: null,
      genders: [
        { name: 'ولد', id: 1 },
        { name: 'بنت', id: 2 },
      ],
      types: [
        { name: 'عام', id: 1 },
        { name: 'أزهر', id: 2 },
      ],
      user_id: JSON.parse(localStorage.getItem("user")).id,
    };
  },
  validations() {
    return {
      student_name: { required },
      student_phone: { required },
      parent_phone: { required },
      selected_type: { required },
    };
  },
  methods: {
    onFileChange(event) {
      this.fileData = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = () => (this.imageEntry = reader.result);
    },
    onlyNumbers(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9٠-٩]/.test(char)) { event.preventDefault(); return; }
      const value = event.target.value;
      const digitsCount = (value.match(/[0-9٠-٩]/g) || []).length;
      if (digitsCount >= 11) event.preventDefault();
    },
    toEnglishDigits(str) {
      if (!str) return str;
      return str.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
    },
    sendForm() {
      this.v$.$validate();
      if (this.v$.$error) return;

      const formData = new FormData();
      formData.append('user_id', this.user_id);
      formData.append('student_name', this.student_name);
      formData.append('student_phone', this.toEnglishDigits(this.student_phone));
      formData.append('parent_phone', this.toEnglishDigits(this.parent_phone));
      if (this.address) formData.append('address', this.address);
      if (this.selected_gender) formData.append('gender', this.selected_gender.id);
      formData.append('education_type', this.selected_type.id);
      if (this.math_degree) formData.append('math_degree', this.math_degree);
      if (this.fileData instanceof File) formData.append("certificate_image", this.fileData);

      this.formSending = true;
      axios.post('/update_user', formData)
        .then(() => {
          Swal.fire({
            position: "center", icon: "success", title: "تم تحديث بيانات الطالب بنجاح",
            text: this.student_phone != this.user?.phone
              ? "تم تغيير كلمة المرور لرقم هاتفك الجديد " + this.student_phone
              : "",
          });
        })
        .catch((error) => {
          Swal.fire({ position: "center", icon: "error", title: error.response?.data?.message });
        })
        .finally(() => { this.formSending = false; });
    },
    fetchUserData() {
      const formData = new FormData();
      formData.append('user_id', this.user_id);
      axios.post('/get_user', formData)
        .then((response) => {
          this.user = response.data.user;
          this.student_name = this.user?.name;
          this.student_phone = this.user?.phone;
          this.parent_phone = this.user?.parent_phone;
          this.address = this.user?.address;
          this.math_degree = response.data.math_degree;
          this.gender = this.user?.gender;
          this.selected_gender = this.genders.find(g => g.id === this.user?.gender);
          this.education_type = this.user?.education_type;
          this.selected_type = this.types.find(t => t.id === this.user?.education_type);
          this.certificate_image = this.user?.certificate_image;
        })
        .catch(() => { this.user = {}; })
        .finally(() => { this.pageLoading = false; });
    },
  },
  mounted() {
    this.fetchUserData();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800&display=swap');
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.ud-page {
  min-height: calc(100vh - 70px);
  background: #0D0D0D;
  font-family: 'Cairo', sans-serif;
  direction: rtl;
  padding: 2rem 0 4rem;
}
.ud-container { max-width: 860px; margin: 0 auto; padding: 0 1.25rem; }

/* ── Header ── */
.ud-header { text-align: center; padding: 2rem 1rem 1.75rem; }
.ud-header-icon {
  width: 70px; height: 70px;
  background: linear-gradient(135deg, #D4AF37, #C89B2D);
  border-radius: 22px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: 0 16px 40px rgba(212,175,55,0.3);
}
.ud-header-icon svg { width: 34px; height: 34px; stroke: #fff; }
.ud-header-title {
  font-size: 1.8rem; font-weight: 800; color: #F0EDE4; margin-bottom: 0.4rem;
}
.ud-header-sub { font-size: 0.9rem; color: rgba(240,237,228,0.6); }

/* ── Card ── */
.ud-card {
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border-radius: 28px;
  padding: 2.25rem 2rem;
  box-shadow: 0 20px 60px rgba(212,175,55,0.1), 0 4px 16px rgba(0,0,0,0.06);
  border: 1px solid rgba(255,255,255,0.9);
}

/* ── Section ── */
.ud-section { margin-bottom: 1.75rem; }
.ud-section-label {
  display: flex; align-items: center; gap: 0.6rem;
  font-size: 0.88rem; font-weight: 800;
  color: #D4AF37; margin-bottom: 1rem;
  letter-spacing: 0.02em;
}
.ud-section-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: linear-gradient(135deg, #D4AF37, #C89B2D);
  flex-shrink: 0;
}

/* ── Fields grid ── */
.ud-fields-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

/* ── Field ── */
.ud-field { display: flex; flex-direction: column; gap: 0.4rem; }
.ud-label {
  font-size: 0.84rem; font-weight: 700; color: #374151;
  display: flex; align-items: center; gap: 0.35rem;
}
.ud-req { color: #EF4444; font-size: 0.9rem; }
.ud-opt { color: #22C55E; font-size: 0.75rem; font-weight: 600; }

.ud-input-wrap { position: relative; display: flex; align-items: center; }
.ud-icon {
  position: absolute; right: 13px;
  width: 18px; height: 18px;
  color: #9CA3AF; pointer-events: none;
  display: flex; align-items: center; justify-content: center;
}
.ud-icon svg { width: 16px; height: 16px; }

.ud-input {
  width: 100%;
  padding: 0.8rem 2.5rem 0.8rem 1rem;
  border: 2px solid #E5E7EB;
  border-radius: 13px;
  font-family: 'Cairo', sans-serif;
  font-size: 0.92rem; color: #1A1A1A;
  background: #F9FAFB;
  outline: none;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
}
.ud-input:focus {
  border-color: #D4AF37;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(212,175,55,0.1);
}
.ud-field--error .ud-input { border-color: #EF4444; box-shadow: 0 0 0 4px rgba(239,68,68,0.08); }
.ud-field--error .ud-icon { color: #EF4444; }
.ud-error { font-size: 0.76rem; color: #EF4444; font-weight: 600; }

/* ── Type selector (pill buttons) ── */
.ud-type-options { display: flex; gap: 0.75rem; flex-wrap: wrap; }
.ud-type-btn {
  padding: 0.65rem 1.75rem;
  border: 2px solid #E5E7EB;
  border-radius: 99px;
  background: #F9FAFB;
  font-family: 'Cairo', sans-serif;
  font-size: 0.92rem; font-weight: 700;
  color: #6B7280; cursor: pointer;
  transition: all 0.25s;
}
.ud-type-btn:hover { border-color: #D4AF37; color: #D4AF37; background: rgba(212,175,55,0.05); }
.ud-type-btn--active {
  background: linear-gradient(135deg, #D4AF37, #C89B2D);
  border-color: transparent; color: #fff;
  box-shadow: 0 8px 20px rgba(212,175,55,0.3);
}

/* ── Phone warning ── */
.ud-phone-warn {
  display: flex; align-items: flex-start; gap: 0.65rem;
  background: rgba(245,158,11,0.08);
  border: 1.5px solid rgba(245,158,11,0.25);
  border-radius: 13px;
  padding: 0.8rem 1rem;
  margin-top: 1rem;
  color: #92400e; font-size: 0.85rem; font-weight: 600;
  line-height: 1.5;
}
.ud-warn-icon { width: 18px; height: 18px; flex-shrink: 0; stroke: #D97706; margin-top: 2px; }

/* ── Actions ── */
.ud-actions { display: flex; justify-content: flex-end; padding-top: 0.5rem; }
.ud-submit {
  padding: 0.9rem 2.75rem;
  border: none; border-radius: 14px;
  background: linear-gradient(135deg, #D4AF37, #C89B2D);
  color: #fff;
  font-family: 'Cairo', sans-serif;
  font-size: 1rem; font-weight: 800;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(212,175,55,0.35);
  transition: all 0.3s;
  display: flex; align-items: center; justify-content: center;
  min-height: 52px; min-width: 180px;
}
.ud-submit:hover:not(:disabled) { transform: translateY(-3px); box-shadow: 0 20px 45px rgba(212,175,55,0.45); }
.ud-submit:disabled { opacity: 0.75; cursor: not-allowed; }

.ud-spinner {
  width: 22px; height: 22px;
  border: 3px solid rgba(255,255,255,0.35);
  border-top-color: #fff; border-radius: 50%;
  animation: udSpin 0.8s linear infinite; display: inline-block;
}
@keyframes udSpin { to { transform: rotate(360deg); } }

/* ── Skeleton ── */
.ud-skeleton { pointer-events: none; }
.skel {
  background: linear-gradient(90deg,#f0f0f0 25%,#e6e6e6 50%,#f0f0f0 75%);
  background-size: 200% 100%;
  animation: udSkel 1.4s infinite; border-radius: 10px;
}
@keyframes udSkel { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
.skel-title { height: 22px; width: 50%; border-radius: 8px; }
.skel-field { height: 52px; border-radius: 13px; }
.skel-btn { height: 52px; width: 180px; border-radius: 14px; margin-right: auto; }

@media (max-width: 600px) {
  .ud-card { padding: 1.75rem 1.25rem; border-radius: 20px; }
  .ud-actions { justify-content: stretch; }
  .ud-submit { width: 100%; }
  .ud-fields-grid { grid-template-columns: 1fr; }
}
</style>
